"use strict";
exports.MediaStreamTypes = {
    MP4: 'MP4',
    WEBM: 'WEBM',
    HLS: 'HLS',
    DASH: 'DASH'
};
var MediaStreamDeliveryType;
(function (MediaStreamDeliveryType) {
    MediaStreamDeliveryType[MediaStreamDeliveryType["NATIVE_PROGRESSIVE"] = 0] = "NATIVE_PROGRESSIVE";
    MediaStreamDeliveryType[MediaStreamDeliveryType["ADAPTIVE_VIA_MSE"] = 1] = "ADAPTIVE_VIA_MSE";
    MediaStreamDeliveryType[MediaStreamDeliveryType["NATIVE_ADAPTIVE"] = 2] = "NATIVE_ADAPTIVE";
})(MediaStreamDeliveryType = exports.MediaStreamDeliveryType || (exports.MediaStreamDeliveryType = {}));
;
//# sourceMappingURL=media-stream.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/types/media-stream.js
// module id = 1426
// module chunks = 0 1 2 3